(function($, undefined) {
	
	'use strict';
	var notificationUtils;
	var formValidator;

	var auditionId;
	var auditionState;
	
	var updateAllSelected = function () {
		var t = $(this);
		if (t.is(':checked')) {
			$('.auditions-invitation-select-invite-chk').prop('checked', true);
		} else {
			$('.auditions-invitation-select-invite-chk').prop('checked', false);
		}
		
		updateSelected();
	};
	
	/**
	 * update selected artists
	 * @param  {[array]} selectedArtists [optionnal]
	 */
	var updateSelected = function (selectedArtists) {
		if (selectedArtists && selectedArtists.length > 0) {
			$('.auditions-invitation-select-item:not(.hide)').each(function(i, el) {
				if (selectedArtists.indexOf($(el).attr('data-id')) != -1) {
					$(el).find('.auditions-invitation-select-invite-chk').prop("checked", true);
					$(el).find('.auditions-invitation-select-invite-chk').trigger("change");
				}
			});
		}
		var allChk = $('.auditions-invitation-select-item:not(.hide) .auditions-invitation-select-invite-chk:checked');
		var allNotChk = $('.auditions-invitation-select-item.hide .auditions-invitation-select-invite-chk, .auditions-invitation-select-invite-chk:not(:checked)');
		var total = $('.auditions-invitation-select-item:not(.hide) .auditions-invitation-select-invite-chk').length;
		var totalChk = allChk.length;
		var artistsChk = allChk.filter(function() {
			return $(this).closest('.auditions-invitation-select-item').attr('data-type') === '0';
		});
		var agenciesChk = allChk.filter(function() {
			return $(this).closest('.auditions-invitation-select-item').attr('data-type') === '2';
		});
		$('.auditions-invitation-artist-count').html(artistsChk.length);
		$('.auditions-invitation-agency-count').html(agenciesChk.length);
		// var newNameList = '';
		
		allChk.each(function () {
			var t = $(this);
			var item = t.closest('.auditions-invitation-select-item');
			var id = item.attr('data-id');
			var clone = $('.audition-availability-questions-ctn.clone').clone();
			var toggleBtn = clone.find('.audition-availability-toggle-btn');
			var concurrencyCheck = clone.find('.concurrent-participation-check');
			var availabilityCheck = clone.find('.audition-availability-check');
			var artistRecordingCheck = clone.find('.artist-recording-check');
			
			item.addClass('selected');

			if ($('.popup[data-id="audition-send-invitations"]').find('.audition-availability-questions-ctn[data-id=' + id + ']').length === 0) {
				clone.find('.audition-availability-person-name').html($.trim($('.auditions-invitation-select-name', item).text()));
				clone.attr('data-id', item.attr('data-id'));
				$(toggleBtn, clone).attr('data-id', $(toggleBtn, clone).attr('data-id') + id);
				$('.audition-availability-questions-content-ctn', clone).attr('data-id', $(toggleBtn, clone).attr('data-id'));
				$(concurrencyCheck, clone).attr('data-id', $(concurrencyCheck, clone).attr('data-id') + id);
				$('.concurrent-participation-details-ctn', clone).attr('data-id', $(concurrencyCheck, clone).attr('data-id'));
				$(availabilityCheck, clone).attr('data-id', $(availabilityCheck, clone).attr('data-id') + id);
				$('.audition-availability-details-ctn', clone).attr('data-id', $(availabilityCheck, clone).attr('data-id'));
				$(artistRecordingCheck, clone).attr('data-id', $(artistRecordingCheck, clone).attr('data-id') + id);
				$('.artist-recording-details-ctn', clone).attr('data-id', $(artistRecordingCheck, clone).attr('data-id'));

				clone.removeClass('clone hide');
				$('.popup[data-id="audition-send-invitations"]').find('.audition-availability-artists-ctn').append(clone);
			}
			// if (newNameList !== '') {
			// 	newNameList += ', ';
			// }
			
			// newNameList += $.trim($('.auditions-invitation-select-name', item).text());
		});
		
		allNotChk.each(function () {
			var t = $(this);
			var item = t.closest('.auditions-invitation-select-item');
			var id = item.attr('data-id');
			
			$('.popup[data-id="audition-send-invitations"]').find('.audition-availability-questions-ctn[data-id=' + id + ']').remove();
			item.removeClass('selected');
		});
		
		// if (!sendInvitePopup.hasClass('agency-invites')) {
		// 	$('.action-form-item', sendInvitePopup).html(newNameList);
		// } else {
			$('.popup[data-id="audition-send-invitations"] .audition-availability-selected-artists-count').html(allChk.length);
		// }
		
		if (total === totalChk) {
			$('.auditions-invitation-select-all-chk').prop('checked', true);
		} else {
			$('.auditions-invitation-select-all-chk').prop('checked', false);
		}
		
		if (totalChk !== 0) {
			$('.auditions-invitation-send-invite-btn').removeClass('disabled').removeAttr('disabled');
			$('.js-audition-send-invitations').removeClass('disabled').removeAttr('disabled');
		} else {
			$('.auditions-invitation-send-invite-btn').addClass('disabled').attr('disabled', 'true');
			$('.js-audition-send-invitations').addClass('disabled').attr('disabled', 'true');
		}
	};
	
	var invertNameList = function () {
		$('.auditions-invitation-select').toggleClass('inverted');
	};
	
	/**
	 * Update filter list
	 * @param  {array} selectedArtists [optional]
	 */
	var updateFilterList = function (selectedArtists) {
		var catSelectValue = $('.auditions-invitation-select-cat').val();
		var criteriaSelectValue = $('.auditions-invitation-select-criteria').val();
        
        if (!catSelectValue) {
            $('.auditions-invitation-count-item').removeClass('hide');
        } else {
            $('.auditions-invitation-count-item.cat-' + catSelectValue).removeClass('hide');
            $('.auditions-invitation-count-item:not(.cat-' + catSelectValue + ')').addClass('hide');
        }
        
		$('.auditions-invitation-select-item').each(function () {
			var t = $(this);
			var catVal = t.attr('data-type');
			//var criteriaVal = t.attr('data-criteria'); Unused
			var foundInProfile = t.attr('data-found-in-profile') === 'true';
			var foundInDemos = t.attr('data-found-in-demos') === 'true';
			
			var hideCat = catVal !== catSelectValue && catSelectValue.length !== 0;
			// La condition démo ne fait pas de sens, var si c'est dans démo, c'Est automatiquement dans profil.
			// J'enlève le choix demo du select, car ça revient au même que "all"
			var hideCriteria =  criteriaSelectValue !== '' && 
								((criteriaSelectValue === 'demo' && !(foundInDemos && !foundInProfile)) ||
								(criteriaSelectValue === 'profile' && !(!foundInDemos && foundInProfile)) || 
								(criteriaSelectValue === 'all' && !(foundInDemos && foundInProfile)));
			
			if (hideCat || hideCriteria) {
				t.addClass('hide');
			} else {
				t.removeClass('hide');
			}
		});
		
		updateSelected(selectedArtists);
	};
	
	var sendInvite = function () {
		var redirect = $(this).attr('data-redirect');
		var allChk = $('.auditions-invitation-select-item:not(.hide) .auditions-invitation-select-invite-chk:checked');
		var arrayId = '';
		var jsons = '';
		var artistIds = [];
		var agencyIds = [];
		var agencyIndirectArray = {};
		var count = 3;
		var popup = $('.popup[data-id="audition-send-invitations"]');
        var questioners = popup.find('.audition-availability-questions-ctn:not(.clone)');
		var hasInvitationDetails = questioners.find('.audition-availability-questions-content-ctn').length > 0;

		if (hasInvitationDetails) {
			questioners.each(function() {
				formValidator.validateForm($(this));
			});

			if (questioners.filter('.has-error').length > 0) {
				return false;
			}
		}
        if (!allChk.length) {
            // No invitees selected
            return false;
        }
		
		allChk.each(function () {
			var t = $(this);
			var item = t.closest('.auditions-invitation-select-item');
			var personId = item.attr('data-id');
			var currAgencyArray = item.attr('data-agency').split(',');
			
			if (arrayId !== '') {
				arrayId += ',';
			}
			
			arrayId += personId;
			
			if (jsons !== '') {
				jsons += '~';
			}

			if (hasInvitationDetails) {
				var personDetails = popup.find('.audition-availability-questions-ctn[data-id=' + personId + ']');
				var json = {
					"no-concurrence": personDetails.find('.concurrent-participation-check').prop('checked'),
					"concurrence-details": personDetails.find('input[name="concurrent-participation-details"]').val(),
					"availability": personDetails.find('.audition-availability-check').prop('checked'),
					"availability-details": personDetails.find('input[name="audition-availability-details"]').val(),
					"artist-recording": personDetails.find('.artist-recording-check').prop('checked'),
					"artist-recording-details": personDetails.find('input[name="artist-recording-details"]').val()
				};
				jsons += JSON.stringify(json);
			} else {
				// send empty json anyways so it gets assigned to proper artist in the application gendata
				jsons += JSON.stringify({});
			}
			
			if (item.attr('data-agency') === '' || item.attr("data-autonome") === 'true') {
				artistIds.push(personId);
			} else if (item.attr('data-type') === '2') {
				agencyIds.push(personId);
			} else if (item.attr('data-agency').length !== 0) {
				for(var k=0;k<currAgencyArray.length;k++) {
					var id = currAgencyArray[k];
					if (id.length) {
						agencyIndirectArray[id] = {
							name: item.attr('data-name'),
							artistId: personId
						};
					}
				}
			}
		});
		
		var _complete = function() {
			count--;
			if (count <= 0) {
				if (auditionState === '0') {
					$.ajax({
						url: '/action/manageGenData',
						cache: false,
						method: 'POST',
						data: {
							id: auditionId,
							field13: '1',
							ajax: true
						},
						success: function (response) {
							window.location.href = redirect;
						}
					});
				} else {
					window.location.href = redirect;
				}
			}
		};
		
		var data = {
			auditionId: auditionId,
			personIds: arrayId,
			jsons: jsons,
			ajax: true
		};

		popup.addClass('is-processing');
		$.ajax({
			url: '/action/vcSendAuditionInvitations',
			cache: false,
			method: 'POST',
			data: data,
			success: function (response) {
				if (artistIds.length) {
					notificationUtils.sendNotificationPerson(
						artistIds.join(','), 
						'AUDITION_ARTIST',
						$('.auditions-invitation-audition-name').val() + '*|||*' + $('.auditions-invitation-audition-uri').val(),
						_complete,
						{ field8: $('.auditions-invitation-sender-id').val() }
					);
				} else {
					_complete();
				}
				if (agencyIds.length) {
					notificationUtils.sendNotificationPerson(
						agencyIds.join(','), 
						'AUDITION_AGENCY',
						$('.auditions-invitation-audition-name').val() + '*|||*' + $('.auditions-invitation-audition-uri').val(),
						_complete,
						{ field8: $('.auditions-invitation-sender-id').val() }
					);
				} else {
					_complete();
				}
				var agencyIndirectArrayLength = Object.keys(agencyIndirectArray).length;
				if(agencyIndirectArrayLength) {
					var agencyIndirectCount = 0;
					for(var key in agencyIndirectArray) {
						notificationUtils.sendNotificationPerson(
							key, 
							'AUDITION_AGENCY_FOR_ARTIST',
							$('.auditions-invitation-audition-name').val() + '*|||*' + agencyIndirectArray[key].name + '*|||*' + $('.auditions-invitation-audition-uri').val() + '?i=' + agencyIndirectArray[key].artistId,
							function() {
								agencyIndirectCount++;
								
								if (agencyIndirectCount === agencyIndirectArrayLength) {
									_complete();
								}
							},
							{ field8: $('.auditions-invitation-sender-id').val() }
						);
					}
				} else {
					_complete();
				}
			}
		});
	};
	
	var checkForListReload = function (e, th) {
		var t = (th !== undefined) ? th : $(this);
		var list = $('.auditions-invitation-select-list');
		var ctn = $('.auditions-invitation-select');
		var data = {};
			
		ctn.addClass('is-processing');

		$('.filters-ctn-js').find('input').each(function(i) {
			if ($(this).val().length !== 0) {
				data[$(this).attr('name')] = $(this).val().trim();
			}
		});

		if($('input[name=studio]').is(":checked")){
			data["studio"] = "true";
		}
        
		if($('input[name=sourceConnect]').is(":checked")){
			data["sourceConnect"] = "true";
		}
        
		if($('input[name=displayAll]').is(":checked")){
			data["displayAll"] = "true";
		}
		
		var selectedArtists = $.map($('.auditions-invitation-select-item.selected'), function(e) {
			return $(e).attr('data-id');
		});

		
		$.ajax({
			url: window.location.href,
			cache: false,
			method: 'POST',
			data: data,
			success: function (response) {
				var temp = $('<div></div>');
				temp.html(response);
				if (t.attr('name') === 'displayAll' || t.attr('name') === 'studio' || t.attr('name') === 'sourceConnect') {
					list.html($('.auditions-invitation-select-list', temp).html());
				} else {
					ctn.html($('.auditions-invitation-select', temp).html());
				}
				// selectChk = $('.auditions-invitation-select-invite-chk');
				
				ctn.removeClass('is-processing');
				updateFilterList(selectedArtists);
			}
		});
	};
	
	var updateSearch = function () {
		var q = $('.auditions-invitation-select-input').val().toLowerCase();
		
		$('.auditions-invitation-select-item').each(function () {
			var t = $(this);
			var name = t.attr('data-name').toLowerCase();
			var info = $('.auditions-invitation-select-info', t).text().toLowerCase();
			var email = t.attr('data-email').toLowerCase();
			var agencyName = '';
			if (t.attr('data-agencyname') !== undefined) {
				agencyName = t.attr('data-agencyname').toLowerCase();
			}
			var criteria = $('.auditions-invitation-select-cell.criteria', t).text().toLowerCase();
			var isOk = false;

			// console.log(agencyName.indexOf(q))
			
			if (email.indexOf(q) !== -1 || name.indexOf(q) !== -1 || 
				info.indexOf(q) !== -1 || criteria.indexOf(q) !== -1 || agencyName.indexOf(q) !== -1) {
				isOk = true;
			}
			
			if (isOk) {
				t.removeClass('hide-search');
			} else {
				t.addClass('hide-search');
			}
		});
	};
	
	// var emptyInvitesList = function() {
	// 	setTimeout(function() {
	// 		sendInvitePopup.find('.audition-availability-questions-ctn:not(.clone)').remove();
	// 	}, 300);
	// };

	var removeSelectedPerson = function() {
		var t = $(this);
		var ctn = t.closest('.audition-availability-questions-ctn');
		var id = ctn.attr('data-id');

		ctn.slideUp();
		$('.auditions-invitation-select-item[data-id=' + id +']').find('.auditions-invitation-select-invite-chk').trigger('click');
	};
    
      
	var changeStudioFilter = function() {
		var t = $(this);

		if (t.is(':checked')) {
            $('.auditions-invitation-sourceConnect-chk').prop("checked", true);
		} else {
            $('.auditions-invitation-sourceConnect-chk').prop("checked", false);            
        }
        
        checkForListReload(t);
	};
    
	var changeSourceConnectFilter = function() {
		var t = $(this);


        if ($('.auditions-invitation-studio-chk').is(":checked")) {
            t.prop('checked', true);
            return;
        }
        checkForListReload(t);

	};

	var init = function () {
		notificationUtils = Fw.component.models().notificationUtils;
		formValidator = Fw.component.models().form;
		
		auditionId = $('.auditions-invitation-audition-id').val();
		auditionState = $('.auditions-invitation-audition-state').val();
		var hasPresets = false;

		$('.filters-ctn-js').find('input').each(function(i) {
			if ($(this).val().length !== 0) {
				hasPresets = true;
			}
		});
        hasPresets = $('.auditions-invitation-studio-chk').is(':checked') || $('.auditions-invitation-sourceConnect-chk').is(':checked');
        
		if (hasPresets && $('.filters-bar.invitations').length > 0) {
			checkForListReload();
		}
		updateSelected();

		$('.auditions-invitation').on('change', '.auditions-invitation-select-all-chk', updateAllSelected);
		$('.auditions-invitation').on('change', '.auditions-invitation-select-invite-chk', updateSelected);
		$('.auditions-invitation').on('click', '.auditions-invitation-select-invert-name', invertNameList);
		$('.auditions-invitation').on('keyup', '.auditions-invitation-select-input', updateSearch);
		$('.auditions-invitation').on('change', '.auditions-invitation-select-cat', updateFilterList);
		$('.auditions-invitation').on('change', '.auditions-invitation-select-criteria', updateFilterList);
//		$('.auditions-invitation').on('click', '.auditions-invitation-studio-chk', changeStudioFilter);
//		$('.auditions-invitation').on('click', '.auditions-invitation-sourceConnect-chk', changeSourceConnectFilter);
		$('.auditions-invitation').on('click', '.auditions-invitation-studio-chk', checkForListReload);
		$('.auditions-invitation').on('click', '.auditions-invitation-sourceConnect-chk', checkForListReload);
		$('body').on('click', '.js-audition-send-invitations', sendInvite);
		$('.auditions-invitation-send-invite-btn').click(updateSelected);
		$('body').on('click', '.audition-availability-remove-artist-btn', removeSelectedPerson);
		// $('.js-popup-close-btn', sendInvitePopup).click(emptyInvitesList);
		$('.auditions-invitation').on('click', 'input[name=displayAll]', checkForListReload);
	};
	
	$(window).ready(init);
	
})(jQuery);
